import { render, staticRenderFns } from "./RaterRateeCard.vue?vue&type=template&id=f9b6b112&"
import script from "./RaterRateeCard.vue?vue&type=script&lang=ts&"
export * from "./RaterRateeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports